/**
 * True when an email-send failure is really "the sender's OAuth token can't be
 * refreshed — the account must be reconnected". Matches the messages thrown by
 * useEmailSender / useEmailProvider ("No access token available. Please
 * reconnect…", "Email account needs to be reconnected…") and the campaign
 * activation pre-check ("Reconnect {email} before sending — …").
 */
export function isReconnectError(err: unknown): boolean {
  const msg =
    err instanceof Error ? err.message : typeof err === 'string' ? err : '';
  return /reconnect|no access token/i.test(msg);
}
